import React from 'react'

import { Box, Button, FormField, Grid, Textarea } from '@cloudscape-design/components';
import { ReactNode } from 'react'

export type LabeledTextareaProps = {
    label: string,
    value: string, 
    onChange: (newValue: string) => void, 
    validate?: (value: string, label: string) => boolean,
    readOnly: boolean, 
    [rest: string]: any,
}

export default ({ label, value, onChange, validate, readOnly, ...rest }: LabeledTextareaProps): ReactNode => {

    // if (readOnly) {
    //     return (
    //         <div>
    //             {label + ': '}
    //             <b style={{width: '100px'}}>{value}</b>
    //         </div> 
    //     ) 
    // }

    const valid = (!readOnly && validate) ? validate(value, label) : true

    return (
        <FormField label={label} info={!validate ? 'Optional' : ''} >
            {/* <Button data-top-right iconName="microphone" variant="icon" ariaLabel="Dictate" onClick={SpeechToText} /> */}
            <Textarea readOnly={readOnly}
                value={value}
                onChange={(event) => onChange(event.detail.value)}
                invalid={!valid}
                {...rest}
            />
        </FormField> 
    )

    function SpeechToText() {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
        const recognition = new SpeechRecognition()
        // recognition.lang = 'en-US'
        recognition.interimResults = true
        recognition.continuous = true
        recognition.onresult = (event: any) => {
            const transcript = event.results[0][0].transcript
            // Here you can set the value of the textarea or input field
            // For example: setValue(transcript)
            onChange(transcript)
        }

        recognition.start()
    }

}


// npm install --save @types/dom-speech-recognition